// John Eldhose 20180511
const LanguageSelected = (language) => ({
  type: 'LANGUAGE_SELECTED',
  language
});

export default LanguageSelected;



// WEBPACK FOOTER //
// ./src/actions/LanguageSelected.js